(() => {
  const initialize = (scope = document) => {
    const headers = scope.matches?.('.brio-banner-header')
      ? [scope]
      : [...scope.querySelectorAll('.brio-banner-header')];

    headers.forEach((header) => {
      if (header.dataset.brioMegaReady) return;
      const trigger = header.querySelector('[data-brio-mega-trigger]');
      const panel = header.querySelector('[data-brio-mega-panel]');
      const backdrop = header.querySelector('[data-brio-mega-backdrop]');
      if (!trigger || !panel || !backdrop) return;
      header.dataset.brioMegaReady = 'true';
      document.body.append(backdrop);

      const desktop = matchMedia('(min-width: 1001px)');
      let openedByHover = false;
      let closeTimer;

      const prepareImages = () => {
        panel.querySelectorAll('img').forEach((image) => {
          if (image.complete && image.naturalWidth) image.classList.add('is-loaded');
          else image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
          image.loading = 'eager';
        });
      };
      const close = (restoreFocus = false) => {
        clearTimeout(closeTimer);
        if (!header.classList.contains('is-mega-open')) return;
        header.classList.remove('is-mega-open');
        backdrop.classList.remove('is-visible');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
        openedByHover = false;
        if (restoreFocus) trigger.focus();
      };
      const open = (fromHover = false) => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        if (header.classList.contains('is-mega-open')) return;
        openedByHover = fromHover;
        backdrop.style.top = `${Math.max(0, header.getBoundingClientRect().bottom)}px`;
        prepareImages();
        panel.removeAttribute('inert');
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        header.classList.add('is-mega-open');
        backdrop.classList.add('is-visible');
      };

      trigger.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) open(true);
      });
      trigger.addEventListener('click', (event) => {
        if (!desktop.matches) return;
        if (openedByHover && event.detail > 0) {
          close();
          return;
        }
        event.preventDefault();
        if (header.classList.contains('is-mega-open')) close();
        else open();
      });
      header.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || panel.contains(document.activeElement)) return;
        closeTimer = setTimeout(() => close(), 180);
      });
      header.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      header.addEventListener('focusout', (event) => {
        if (!header.contains(event.relatedTarget)) close();
      });
      backdrop.addEventListener('click', () => close());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && header.classList.contains('is-mega-open')) close(true);
      });
      window.addEventListener('scroll', () => close(), { passive: true });
      window.addEventListener('resize', () => {
        if (!desktop.matches) close();
        else if (header.classList.contains('is-mega-open'))
          backdrop.style.top = `${Math.max(0, header.getBoundingClientRect().bottom)}px`;
      }, { passive: true });

      const mobileMenu = header.querySelector('.brio-mobile-menu');
      mobileMenu?.querySelectorAll('nav a').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (event.defaultPrevented) return;
          const destination = new URL(link.href, location.href);
          if (destination.origin === location.origin && destination.pathname === location.pathname && destination.search === location.search)
            mobileMenu.open = false;
        });
      });
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
